import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WarehousePositionForm } from './-form'
import { useCreateWarehousePosition } from '@/hooks/use-warehouse-position-query'
import { m } from '@/lib/paraglide/messages'
import { PageBackButton } from '@/components/common/PageBackButton'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/warehouse-positions/new',
)({
    component: NewWarehousePositionPage,
})

function NewWarehousePositionPage() {
    const navigate = useNavigate()
    const create = useCreateWarehousePosition()

    return (
        <div className="space-y-4 page-pad md:space-y-6">
            <div className="flex min-w-0 items-center gap-2">
                <PageBackButton className="-my-2 md:-my-1" />
                <h1 className="text-xl font-semibold">
                    {m.warehouse_position_new_title()}
                </h1>
            </div>
            <WarehousePositionForm
                submitLabel={m.warehouse_position_submit_create()}
                onSubmit={async (data) => {
                    const res = await create.mutateAsync({
                        code: data.code,
                        name: data.name || undefined,
                        applicable_lot_types: data.applicable_lot_types,
                        is_pos_shelf: data.is_pos_shelf ?? false,
                    })
                    const id = res.data?.id
                    if (id) {
                        void navigate({
                            to: '/warehouse-positions/$id',
                            params: { id },
                        })
                    }
                }}
            />
        </div>
    )
}
